import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupByEventName',
})
export class GroupByEventName implements PipeTransform {
    transform(value, args: string[]): any {
        const groups = {};
        if (value != null) {
            if (value.length > 0) {
                value.forEach(function(o) {
                    const group = o.EventName;
                    groups[group] = groups[group]
                        ? groups[group]
                        : {
                              EventName: group,
                              HomeTeam: o.HomeTeam,
                              AwayTeam: o.AwayTeam,
                              eEvents: [],
                              EventDate: o.EventDate,
                              SportName: o.SportName,
                              externalDatas: { liveData: o.liveData, cards: o.cards },
                          };
                    groups[group].eEvents.push(o);
                });
            }
        }
        return Object.keys(groups).map(function(key) {
            return groups[key];
        });
    }
}
